import React from 'react';

export const LumaLogoIcon = ({ size = 48, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <defs>
      <filter id="glow-icon">
        <feGaussianBlur stdDeviation="2" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="glow-strong">
        <feGaussianBlur stdDeviation="3.5" result="coloredBlur" />
        <feMerge>
          <feMergeNode in="coloredBlur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>

    {/* Grid lines - faint background */}
    <line x1="30" y1="4" x2="30" y2="56" stroke="rgba(139,92,246,0.2)" strokeWidth="0.5" />
    <line x1="4" y1="30" x2="56" y2="30" stroke="rgba(139,92,246,0.2)" strokeWidth="0.5" />
    <line x1="15" y1="4" x2="15" y2="56" stroke="rgba(139,92,246,0.1)" strokeWidth="0.5" />
    <line x1="45" y1="4" x2="45" y2="56" stroke="rgba(139,92,246,0.1)" strokeWidth="0.5" />
    <line x1="4" y1="15" x2="56" y2="15" stroke="rgba(139,92,246,0.1)" strokeWidth="0.5" />
    <line x1="4" y1="45" x2="56" y2="45" stroke="rgba(139,92,246,0.1)" strokeWidth="0.5" />

    {/* Outer diamond */}
    <path
      d="M30 6 L54 30 L30 54 L6 30 Z"
      stroke="rgba(255,255,255,0.85)"
      strokeWidth="1.2"
      fill="none"
      filter="url(#glow-icon)"
    />

    {/* Inner diamond */}
    <path
      d="M30 16 L44 30 L30 44 L16 30 Z"
      stroke="rgba(139,92,246,0.9)"
      strokeWidth="1"
      fill="none"
      filter="url(#glow-icon)"
    />

    {/* Corner accent dots - outer diamond */}
    <circle cx="30" cy="6" r="2" fill="#8B5CF6" filter="url(#glow-strong)" />
    <circle cx="54" cy="30" r="2" fill="#8B5CF6" filter="url(#glow-strong)" />
    <circle cx="30" cy="54" r="2" fill="#8B5CF6" filter="url(#glow-strong)" />
    <circle cx="6" cy="30" r="2" fill="#8B5CF6" filter="url(#glow-strong)" />

    {/* Inner corner dots */}
    <circle cx="30" cy="16" r="1.5" fill="rgba(139,92,246,0.6)" />
    <circle cx="44" cy="30" r="1.5" fill="rgba(139,92,246,0.6)" />
    <circle cx="30" cy="44" r="1.5" fill="rgba(139,92,246,0.6)" />
    <circle cx="16" cy="30" r="1.5" fill="rgba(139,92,246,0.6)" />

    {/* Center cross lines */}
    <line x1="21" y1="21" x2="39" y2="39" stroke="rgba(255,255,255,0.3)" strokeWidth="0.75" />
    <line x1="39" y1="21" x2="21" y2="39" stroke="rgba(255,255,255,0.3)" strokeWidth="0.75" />

    {/* Center dot - brightest point */}
    <circle cx="30" cy="30" r="3.5" fill="white" filter="url(#glow-strong)" />
    <circle cx="30" cy="30" r="1.5" fill="white" />
  </svg>
);

export const LumaWordmark = ({ size = 'md', className = '' }) => {
  const fontSize = size === 'sm' ? '20px' : size === 'lg' ? '36px' : size === 'xl' ? '48px' : '28px';
  const iconSize = size === 'sm' ? 28 : size === 'lg' ? 44 : size === 'xl' ? 56 : 36;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <LumaLogoIcon size={iconSize} />
      <span
        style={{
          fontFamily: 'Outfit, sans-serif',
          fontSize,
          fontWeight: '700',
          letterSpacing: '-0.02em',
          color: 'white',
          lineHeight: 1,
        }}
      >
        LUMA
      </span>
    </div>
  );
};

export default LumaLogoIcon;
